import React from 'react';
import styled from 'styled-components';
import TemrsContainer from '../view/terms/container/TermsContainer';

const Credit = () => {
  return (
    <Container>
      <TemrsContainer />
    </Container>
  );
};

const Container = styled.div``;

export default Credit;
